import React from 'react';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

// Cancel + submit row shared by the auth dialog forms.
// Mobile: primary action on top, both buttons full width; ≥sm: the usual row.
const FormActions = ({ onCancel, submitLabel, busy = false, submitDisabled = false }) => {
    const { t } = useTranslation();
    const width = { xs: '100%', sm: 'auto' };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column-reverse', sm: 'row' },
                justifyContent: 'space-between',
                gap: 1.5,
            }}
        >
            <Button type="button" variant="outlined" size="large" onClick={onCancel} disabled={busy} sx={{ width }}>
                {t('button.cancel')}
            </Button>
            <Button
                type="submit"
                variant="contained"
                color="secondary"
                size="large"
                disabled={busy || submitDisabled}
                sx={{ width }}
            >
                {submitLabel}
            </Button>
        </Box>
    );
};

export { FormActions };
